<template>

    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-12 p-0">
                <div class=" login-card  card login-dark">
                    <div  >
                        <div class="card-header"  >
                            <h4>Employee Gatepass </h4>
                                                            
                                                            <span v-if="gatepass.check_in!=null" class="badge badge-pill badge-info text-white">
                                                                    Checked In
                                                            </span>
                                                            <span v-else-if="gatepass.check_out!=null" class="badge badge-pill badge-success text-white">
                                                                    Checked Out
                                                            </span>
                                                            <span v-else-if="gatepass.checkout_approval==1" class="badge badge-pill badge-warning text-white">
                                                                    Check Out Approved {{gatepass?.checkout_approval_time}}
                                                            </span>
                                                            <span v-else-if="gatepass.checkout_approval==2" class="badge badge-pill badge-warning text-white">
                                                                    Check Out Denied
                                                            </span>
                                                            <span v-else-if="gatepass.approval_status==0" class="badge badge-pill badge-warning text-white">
                                                                    Pending
                                                            </span>
                                                            <span v-else-if="gatepass.approval_status==1" class="badge badge-pill badge-success text-white">
                                                                    Accepted
                                                            </span>
                                                            <span v-else-if="gatepass.approval_status==2" class="badge badge-pill badge-danger text-white">
                                                                    Denied
                                                            </span>
                        </div>

                        <div class="card-body bg-white">
                            <div class="row">
                                <div class="col-12 text-center">
                                    <canvas ref="qrcodeCanvas"></canvas>
                                </div>
                                <!--<div class="col-4 ">-->
                                <!--    <div class="avatar"><img alt="" class="img img-thumbnail" :src="this.$hostname+'writable/uploads/visitors/'+(gatepass.gphoto?gatepass.gphoto:'user.png')" v-if="gatepass.photo"></div>-->
                                <!--</div>-->
                                <div class="col-12 ">
                                        <b>Emp. Code:</b>  {{ gatepass.empcode }}<br> 
                                        <b>Name :</b>  {{ gatepass.empname }}<br>
                                        <b>Phone No :</b>  {{ gatepass.contact }}<br>
                                         
                                </div>
                            </div>
                            <div class="col-12 mt-4 row"> 
                                <table class="table">
                                   
                                    <tr class="bottomborder">
                                        <td><b>Purpose</b></td>
                                        <td>{{ gatepass.purpose }}</td>
                                    </tr>
                                    <tr class="bottomborder">
                                        <td><b>Schedule Date</b></td>
                                        <td>{{ gatepass.schedule_date+':'+gatepass.emp_chekout }}</td>
                                    </tr>
                                   
                                    <tr v-if="gatepass.check_in" class="bottomborder">
                                        <td><b>Check In</b></td>
                                        <td>{{ gatepass.check_in }}</td>
                                    </tr> 
                                    <tr v-if="gatepass.check_out" class="bottomborder">
                                        <td><b>Check Out</b></td>
                                        <td>{{ gatepass.check_out }}</td>
                                    </tr> 
                                    
                                </table>
                             
                                   
                            </div>
                            <!--<div class="form-group col-12 mt-4 ">-->
                            <!--        {{gatepass.accessories}}-->
                            <!--</div>-->
                            
                            <!--<div class="form-group col-12 mt-4 ">-->
                            <!--  <lable class="col-3"> Visitor Sign</lable> &nbsp;&nbsp;&nbsp;&nbsp;-->
                            <!--  <lable class="col-3"> Employee Sign</lable>&nbsp;&nbsp;&nbsp;&nbsp;-->
                            <!--  <lable class="col-3"> Security Sign</lable>-->
                            <!--</div> -->
                               <div class="card-footer bg-white"  v-if="scan_user && scan_user?.empdept==sd">
                                    
                                    <div class="col-12 row" >
                                        <button class="btn btn-success col-12" v-if="gatepass.checkout_approval==1 && gatepass.check_out==null" @click="mark_checkin(gatepass.token,2)">Check Out</button>
                                        <button v-if="gatepass.checkout_approval==1 && gatepass.check_out!=null  && gatepass.check_in==null"   class="btn btn-danger  col-12" @click="mark_checkin(gatepass.token,1)">Check In</button>
                                        <div v-else-if="gatepass.check_in!=null">
                                            <h4 class="text-danger">All Requests Completed</h4>
                                        </div>
                                    </div> 
                                    
                                </div>
                               <div class="card-footer bg-white"  v-else>
                                    
                                    <div class="col-12 row" v-if="gatepass.checkout_approval!=1 && gatepass.check_out==null && (scan_user &&  scan_user.id==gatepass.whom_userid)">
                                        <button class="btn btn-success col-12" @click="accept(gatepass.token,1)">Approve</button>
                                         
                                        <button v-if="gatepass.checkout_approval==1" class="btn btn-danger  col-12" @click="reject(gatepass.token,2)">Decline</button>
                                    </div>
                                    <div v-else-if="gatepass.checkout_approval==1">
                                        <h4 class="text-danger">Request Approved</h4>
                                    </div>
                                    
                                </div>
                            </div> 
                    </div>
                    <button v-if="scan_user?.empdept==sd" class="btn btn-danger" @click="this.$router.go(-1);">Go Back</button>
                </div>
            </div>
        </div>
    </div>
        
        <audio  ref="checkoutPlayer" src="/sounds/checkout.mp3"></audio>
        <audio  ref="checkinPlayer"  src="/sounds/checkin.mp3"></audio>
        <audio  ref="invalidPlayer"  src="/sounds/invalid.mp3"></audio>
        <audio  ref="pendingPlayer"  src="/sounds/pending.mp3"></audio>
        <audio  ref="photoPlayer"  src="/sounds/photo.mp3"></audio>
 
</template>
<style scoped>
.bottomborder{
    border-bottom: 1px solid grey;
}
.page-body {
    margin-left: 0 !important;
    margin-top: 0px;
}

.user-profile .hovercard .cardheader {
    height: 100px;
    background: linear-gradient(45deg, #0437c8, #007611);
}

@media only screen and (max-width: 575.98px) {
    .tabs-scoial li:nth-child(3) {
        position: sticky;
    }
}
.avatar img{
    width: 100%; 
}
.login-card {
    min-height: 80vh;
}
</style>

<script>
// import axios from 'axios';
import axios from "@/plugins/axios";
import QRCode from 'qrcode';

export default {
    name: 'EmployeeGatepass', 
    mounted() {
            //  alert('yes');
        if (this.$route.query.q) {
                this.getBasics(this.$route.query.q);
            }else
            window.location.href = this.$cur_host+'register';
    },
    
    data() {
        return {  
            gatepass: { "name": '', "firmname": '',"contact": '', "address": '',"purpose": '','designation':'','schedule_date':'','photo':'' } ,
            status:'',
             scan_user:'',
             sd:0,
             showimgModal:false,
             selected_gatepass_captured_img:'',
             imgpassid:0
        }
    },
    
     
    methods: { 
       accept(visitid,what){
            var self = this;
            self.$swal({
                title: "Do You Want To Accept?",
                text: "Just confirmation ?",
                type: "warning",
                showCancelButton: true, 
            }).then((result) => { // <--
                    if(result.value){
                        axios.post('processEmpGatePass', {gatepass_id:visitid,what:what}).then(function (response) {
                            if(response.data.is==1){
                                self.status=response.data.is;
                                self.gatepass=response.data.visit;
                            }
                            
                            self.$swal(response.data.gatepassReq);
                            
                                // window.scrollTo(0, 0);
                            }) 
                    } 
                });
          }, 
        mark_checkin(passid,what) {
            var self = this;
            self.$swal({
                title: "Do You Want To "+(what==1?"Check In":"Check Out")+" ?",
                text: "Just For Confirmation !",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes"
            }).then((result) => { // <--
                if (result.value) { // <-- if confirmed
                
                    
            
                    const formData = new FormData();
                     
                    formData.append('passid', passid);
                    formData.append('what', what);
                    
                    axios.post('checkInEmployeeFromQr', formData).then(function (response) {
                         if(response.data.is==1){
                                self.status=response.data.is;
                                self.gatepass=response.data.visit;
                                
                                
                                 if(response.data?.sound && response.data.sound==1 && response.data.sound_file){
                                         if (self.$refs[response.data.sound_file])
                                             self.$refs[response.data.sound_file].play();
                                         else 
                                          console.warn(`Audio ref "${response.data.sound_file}" does not exist.`);
                                    }
                            
                             setTimeout(function () {
                                        window.location.replace(self.$cur_host + 'MobileScan');
                                    }, 2000);
                            }
                            self.$swal(response.data.msg);
                    });
                }
            });

        },
        getBasics(token) {
            var self = this;
            axios.post('getEmployeePass',{token:token}).then(function (response) {
                   self.gatepass= response.data.gatepass; 
                   self.scan_user= response.data.scan_user; 
                   self.sd= response.data.sd; 
                   self.getQrCode(self.gatepass.token);
                   if(self.gatepass.approval_status==0){
                       if(response.data?.sound && response.data.sound === 1 && response.data.sound_file) {
                              // Create a new audio element instead of using refs
                              const audio = self.$refs[response.data.sound_file];
                              
                              // First try to play (will fail without interaction)
                              audio.play().catch(error => {
                                // If failed, wait for user interaction
                                console.log('Audio play failed, adding click handler');
                                
                                // Add a one-time click handler to play the sound
                                const playOnClick = () => {
                                  audio.play()
                                    .then(() => {
                                      document.removeEventListener('click', playOnClick);
                                    })
                                    .catch(e => console.error('Still failed to play:', e));
                                };
                                
                                document.addEventListener('click', playOnClick, {once: true});
                              });
                            }
                   }
                   
                   
                window.scrollTo(0, 0);
            });
        },
        async getQrCode(token) {
            try {
              if(token.length>0){
                  const canvas = this.$refs.qrcodeCanvas;
                  var url=this.$api_host+'empg?q='+token;
                  await QRCode.toCanvas(canvas,url , { width: 200 });
                  $("#qrcodeView").modal("toggle");
              }
              
            } catch (error) {
              console.error(error);
            }
          },

}
}
</script>
